module.exports = __webpack_public_path__ + "static/logo-dark-8ad08bba3b20ebee00d8b9c7fa6be0d9.svg";